import { render, staticRenderFns } from "./PatientCoachingSummaryPath.vue?vue&type=template&id=2b5aca63"
import script from "./PatientCoachingSummaryPath.vue?vue&type=script&lang=js"
export * from "./PatientCoachingSummaryPath.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports